import { css } from "@emotion/react";
import { Button } from "primereact/button";
import { Sidebar } from "primereact/sidebar";
import { NewWorkspace, spaik } from "../../../assets";
import { useAppDispatch } from "../../../redux/hooks";
import { setModeWorkspaces } from "../../../redux/slices/workspaces";
import { AuthContextType, useAuth } from "../../../auth/auth-provider";
import { useToast } from "../../../components/toast-provider";

interface IWorkspaceSidebar {
  hideSidebar: () => void;
  showDialog: (dialog: string) => void;
  visible: boolean;
}
const WorkspaceSidebar: React.FC<IWorkspaceSidebar> = ({
  hideSidebar,
  showDialog,
  visible
}) => {
  const dispatch = useAppDispatch();
  const toast = useToast();
  const { user, hasAnyPermission } = useAuth() as AuthContextType;

  const allPermission: { [key: string]: string } = {
    workspace: "workspace_create",
    robo: "bot_create",
    profile: "profile_create"
  };

  const onHideSideBar = (dialog: string) => {
    const permission = allPermission[dialog];

    if (hasAnyPermission(permission)) {
      hideSidebar();
      showDialog(dialog);
      dispatch(setModeWorkspaces("add"));
    } else {
      const labelMap: { [key: string]: string } = {
        workspace: "workspace",
        robo: "bot",
        profile: "perfil"
      };

      toast.current?.show({
        life: 5000,
        severity: "error",
        summary: "Erro",
        detail: `Seu usuário não tem permissão para incluir um novo ${labelMap[dialog]}!`
      });
    }
  };

  return (
    <Sidebar
      icons="Adicionar"
      visible={visible}
      onHide={hideSidebar}
      position="right"
      className="wsDialog p-sidebar-sm"
    >
      <div className="flex flex-column mt-1 btnConfiWorkspaceContainer">
        <Button
          onClick={() => onHideSideBar("workspace")}
          aria-label="Secondary"
          className="mt-2 p-button-outlined p-button-secondary btnConfiWorkspace blueColorBtnConfig"
        >
          <div
            css={css`
              display: flex;
            `}
          >
            <div className="px-2 blueIconBTN">
              <img
                src={NewWorkspace}
                width={16}
                height={16}
                css={css`
                  align-items: center;
                  display: flex;
                  justify-content: center;
                `}
              />
            </div>
            <span
              className="px-3 text-sm"
              css={css`
                align-items: center;
                display: flex;
              `}
            >
              Novo workspace
            </span>
          </div>
          <span className="px-3" style={{ color: "#C4CCD8" }}>
            {" "}
            &gt;{" "}
          </span>
        </Button>

        <Button
          onClick={() => onHideSideBar("robo")}
          aria-label="Secondary"
          className="mt-2 p-button-outlined p-button-secondary btnConfiWorkspace blueColorBtnConfig"
        >
          <div
            css={css`
              display: flex;
            `}
          >
            <div className="px-2 blueIconBTN flex align-itens-center justify-content-center">
              <img
                src={user.plataform.urlLogo ? user.plataform.urlLogo : spaik}
                style={{ maxWidth: "25px", maxHeight: "25px" }}
              />
            </div>
            <span
              className="px-3 text-sm"
              css={css`
                align-items: center;
                display: flex;
              `}
            >
              Novo Robô
            </span>
          </div>
          <span className="px-3" style={{ color: "#C4CCD8" }}>
            {" "}
            &gt;{" "}
          </span>
        </Button>

        <Button
          onClick={() => onHideSideBar("profile")}
          aria-label="Secondary"
          className="mt-2 p-button-outlined p-button-secondary btnConfiWorkspace blueColorBtnConfig"
        >
          <div>
            <i className="pi pi-plus px-2 blueIconBTN"></i>
            <span className="px-3 text-sm">Novo perfil</span>
          </div>
          <span className="px-3" style={{ color: "#C4CCD8" }}>
            {" "}
            &gt;{" "}
          </span>
        </Button>
      </div>
    </Sidebar>
  );
};

export default WorkspaceSidebar;
